import type { Components, Theme } from "@mui/material/styles";

import { INPUT_PADDING_SPACING } from "./input-base";

export const DROP_DOWN_SPACING = 3.5;

export const MuiSelect: Components<Theme>["MuiSelect"] = {
  defaultProps: {
    variant: "outlined",
  },
  styleOverrides: {
    root: ({ theme }) => ({
      alignItems: "center",
      display: "flex",
      fontWeight: theme.typography.fontWeightMedium,

      "&&&": {
        // move padding to the select component because the root is not clickable
        padding: 0,
      },
    }),

    select: ({ theme }) => ({
      alignItems: "center",
      display: "flex",
      gap: theme.spacing(1),
      height: theme.spacing(5),
      minHeight: theme.spacing(2),

      "&&": {
        padding: theme.spacing(
          0,
          // leave space for arrow icon
          INPUT_PADDING_SPACING + DROP_DOWN_SPACING,
          0,
          INPUT_PADDING_SPACING,
        ),
      },

      "&:focus": {
        // null prevents the default theme value; just use the root value (allowing others to customize)
        backgroundColor: null,
        borderRadius: null,
      },
    }),

    icon: ({ theme }) => ({
      right: theme.spacing(1),
      transition: theme.transitions.create("transform", {
        duration: theme.transitions.duration.shorter,
      }),
    }),

    standard: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
      transition: theme.transitions.create(["background-color"], {
        duration: theme.transitions.duration.shorter,
      }),
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    }),
  },
};
